/* eslint-disable standard/object-curly-even-spacing */
// @ts-nocheck
// @ts-ignore
import L from 'leaflet'
import { Notification } from 'element-ui'
import * as turf from '@turf/turf'
import bus from '@/components/common/bus'
import { markericon } from './markericon'
import { coordinatesconvert } from '@/views/class/coordinatesconvert'
import { mapResourceApi } from '@/api/mapResourceApi'

const xzqUtils = {
  xzqEidtArray: [],
  xzqArray: [{
    label: '全部',
    value: '0'
  }],
  xzqNameArray: [],
  getXZQNAME(code) {
    debugger
    let xzqname = ''
    const tdata = JSON.parse(localStorage.getItem('xzqUtil_datas'))
    if (tdata == null) {
      xzqname = xzqUtils.initXZQ(code)
      return xzqname
    }
    if (tdata) {
      for (let i = 0; i < tdata.length; i++) {
        if (code === tdata[i].cantoncode) {
          xzqname = tdata[i].cantonname
        }
      }
    }
    return xzqname
  },
  initXZQList() {
    const param = {}
    let cantoncity = '株洲市'
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        cantoncity = city[i].cityname
      }
    }
    param.cantoncity = cantoncity
    mapResourceApi.selectByCityName(param).then(res => {
      if (res.code === '200') {
        if (res.data.length > 0) {
          const txzqArray = [{
            label: '全部',
            value: '0'
          }]
          for (let i = 0; i < res.data.length; i++) {
            const datas = []
            datas.label = res.data[i].cantonname
            datas.value = res.data[i].cantoncode
            txzqArray.push(datas)
          }
          this.xzqArray = txzqArray
        }
      }
    })
  },
  initXZQ(code) {
    const param = {}
    let cantoncity = '株洲市'
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        cantoncity = city[i].cityname
      }
    }
    param.cantoncity = cantoncity
    mapResourceApi.selectByCityName(param).then(res => {
      if (res.code === '200') {
        localStorage.setItem('xzqUtil_datas', JSON.stringify(res.data))
        if (res.data.length > 0) {
          const txzqArray = [{
            label: '全部',
            value: '0'
          }]
          let xzqname = ''
          for (let i = 0; i < res.data.length; i++) {
            const datas = []
            datas.label = res.data[i].cantonname
            datas.value = res.data[i].cantoncode
            txzqArray.push(datas)
            if (code === res.data[i].cantoncode) {
              xzqname = res.data[i].cantonname
            }
          }
          this.xzqArray = txzqArray
          return xzqname
        }
      }
    })
  },
  getXZQCODE(name) {
    let xzqcode = ''
    const tdata = JSON.parse(localStorage.getItem('xzqUtil_datas'))
    for (let j = 0; j < tdata.length; j++) {
      if (name === tdata[j].cantonname) {
        xzqcode = tdata[j].cantoncode
      }
    }
    return xzqcode
  }
}

const LAND_TYPE = {
  land_type_suoyou: 0, // 所有
  land_type_zhuzhai: 1, // 住宅
  land_type_shangye: 2, // 商业
  land_type_gongye: 3, // 工业
  land_type_qita: 4 // 其他
}
const mapmanager = {
  map: null,
  alldataFeatures: [],
  zhuzhaiFeatures: [],
  shangyeFeatures: [],
  gongyeFeatures: [],
  imga: {},
  flag: false,
  id: '',
  /**
   * 初始化地图数据
   * @param {*} features
   */
  intiMapLayer(features) {
    this.alldataFeatures = features
    // 默认类型0，全部类型显示
    this.loadLandMapLayer(this.alldataFeatures, LAND_TYPE.land_type_suoyou)
    this.addMapEventlistener()
  },
  loadLandMapLayer(features, type) {
    if (mapmanager.map) {
      mapmanager.map.landMarkerLayerGroup.clearLayers()
      mapmanager.map.landLayerGroup.clearLayers()
      const zoomlevel = mapmanager.map.getZoom()
      const zzLayer = L.geoJSON(features, {
        filter(geoJsonFeature) {
          // 根据选择的类型，判断当前类型是否显示
          return mapmanager.getVisibleLandType(geoJsonFeature, type)
        },
        style(feature) {
          // 地块的绘制颜色，边框等
          return mapmanager.getLandColor(feature)
        },
        onEachFeature(feature, layer) {
          const ydxz = feature.properties.ydxz // .replace(/^\s+|\s+$/g, '')
          const latlng = mapmanager.getPolygonCenterPoint(feature)
          let marker = null
          marker = L.marker(latlng, { icon: markericon.landMarkerIcon(ydxz), riseOnHover: true })
          marker.bindTooltip(markericon.getTooltipDiv(feature.properties.dkmc), { direction: 'top', offset: L.point(0, -30) })
          debugger
          marker.feature = feature
          mapmanager.map.landMarkerLayerGroup.addLayer(marker)
          if (zoomlevel > 14) {
            mapmanager.map.landLayerGroup.addLabel(latlng, feature.properties.dkmc)
          }
        }
      })
      if (zoomlevel > 14) {
        mapmanager.map.landLayerGroup.addLayer(zzLayer)
      }
    }
  },
  // 添加地图事件
  addMapEventlistener() {
    if (mapmanager.map) {
      mapmanager.map.on('zoomend', e => {
        const zoomL = mapmanager.map.getZoom()
        if (zoomL > 14) {
          mapmanager.map.landLayerGroup.clearLayers()
          this.addMapLabel(mapmanager.map.landMarkerLayerGroup.getLayers())
        } else {
          mapmanager.map.landLayerGroup.clearLayers()
        }
      })
      mapmanager.map.on('click', e => {
        // console.log(e)
      })
    } else {
      console.log('地图监听事件错误....')
    }
  },
  // 添加地图标注
  addMapLabel(layers) {
    if (layers) {
      layers.forEach(layer => {
        const zzLayer = L.geoJSON(layer.feature, {
          style(feature) {
            return mapmanager.getLandColor(feature)
          },
          onEachFeature(feature, layer) {
            const latlng = mapmanager.getPolygonCenterPoint(feature)
            mapmanager.map.landLayerGroup.addLabel(latlng, feature.properties.dkmc)
          }
        })
        mapmanager.map.landLayerGroup.addLayer(zzLayer)
      })
    }
  },
  // 地块绘制的颜色
  getLandColor(feature) {
    const ydxz = feature.properties.ydxz // .replace(/^\s+|\s+$/g, '')
    /*     if (Number(ydxz) === LAND_TYPE.land_type_zhuzhai) {
      return { color: 'red', weight: 2, fillColor: 'red', fillOpacity: 0.2 }
    } else if (Number(ydxz) === LAND_TYPE.land_type_shangye) {
      return { color: '#3a85e9', weight: 2, fillColor: '#3a85e9', fillOpacity: 0.2 }
    } else if (Number(ydxz) === LAND_TYPE.land_type_gongye) {
      return { color: '#1ecc85', weight: 2, fillColor: '#1ecc85', fillOpacity: 0.2 }
    } else if (Number(ydxz) === LAND_TYPE.land_type_qita) {
      return { color: '#d7d366', weight: 2, fillColor: '#d7d366', fillOpacity: 0.2 }
    } */
    return { color: 'red', weight: 2, fillColor: 'red', fillOpacity: 0.2 }
  },
  getVisibleLandType(geoJsonFeature, type) {
    const ydxz = geoJsonFeature.properties.ydxz.replace(/^\s+|\s+$/g, '')
    if (type === LAND_TYPE.land_type_suoyou) {
      return true
    } else if (type === LAND_TYPE.land_type_zhuzhai && Number(ydxz) === type) {
      return true
    } else if (type === LAND_TYPE.land_type_shangye && Number(ydxz) === type) {
      return true
    } else if (type === LAND_TYPE.land_type_gongye && Number(ydxz) === type) {
      return true
    } else if (Number(ydxz) === LAND_TYPE.land_type_qita && Number(ydxz) === type) {
      return true
    }
  },

  getYdxzName(type) {
    const ydxz = type // type.replace(/^\s+|\s+$/g, '')
    if (Number(ydxz) === LAND_TYPE.land_type_suoyou) {
      return '---'
    } else if (Number(ydxz) === LAND_TYPE.land_type_zhuzhai) {
      return '住宅用地'
    } else if (Number(ydxz) === LAND_TYPE.land_type_shangye) {
      return '商服用地'
    } else if (Number(ydxz) === LAND_TYPE.land_type_gongye) {
      return '工业用地'
    } else if (Number(ydxz) === LAND_TYPE.land_type_qita) {
      return '其他用地'
    }
  },
  /***
   *切换图层（地块类型）
   */
  switchMapLayer(type) {
    if (Number(type) === 0) {
      mapmanager.map.fullMap()
    }
    bus.$emit('initView', false)
    this.loadLandMapLayer(this.alldataFeatures, Number(type))
  },

  getPolygonCenterPoint(feature) {
    debugger
    let latlng = [0, 0]
    if (feature.geometry) {
      if (feature.geometry.type === 'MultiPolygon') {
        const multiPolygon = turf.multiPolygon(feature.geometry.coordinates)
        const center = turf.pointOnFeature(multiPolygon)
        latlng = [center.geometry.coordinates[1], center.geometry.coordinates[0]]
        /*   const gcCenter = coordinatesconvert.wgs84togcj02(Number(center.geometry.coordinates[0]), Number(center.geometry.coordinates[1]))
        const gc02Array = gcCenter.split(',')
        latlng = [gc02Array[1], gc02Array[0]] */
        //  new L.latLng(center.geometry.coordinates[0], center.geometry.coordinates[1])
        // console.log(gcCenter)
        /*  const latlng1 = L.CRS.EPSG3857.project(latlng)
        const latlng2 = L.CRS.EPSG3857.unproject(latlng1)
        const wgs84latlnt = coordinatesconvert.lonLat2Mercator(latlng)
        const latlng2 = L.CRS.EPSG3857.unproject(latlng1)
        // console.log(a) */
        //
        debugger
      } else if (feature.geometry.type === 'Polygon') {
        const polygon = turf.polygon(feature.geometry.coordinates[0])
        const center1 = turf.pointOnFeature(polygon)
        latlng = [center1.geometry.coordinates[1], center1.geometry.coordinates[0]]
        /*   const gcCenter = coordinatesconvert.wgs84togcj02(Number(center1.geometry.coordinates[0]), Number(center1.geometry.coordinates[1]))
        const gc02Array = gcCenter.split(',')
        latlng = [gc02Array[1], gc02Array[0]] */
        // new L.latLng(center1.geometry.coordinates[0], center1.geometry.coordinates[1])
        /*        const latlng1 = L.CRS.EPSG3857.project(latlng)
        const latlng2 = L.CRS.EPSG3857.unproject(latlng1)
        const wgs84latlnt = coordinatesconvert.lonLat2Mercator(latlng) */
        /*    const wgs84latlnt = coordinatesconvert.lonLat2Mercator(latlng)
        console.log(wgs84latlnt) */
        // latlng = [center1.geometry.coordinates[1], center1.geometry.coordinates[0]]
        debugger
      }
    }
    return latlng
  },

  getFeatureByCoordinates(coordinates, type) {
    let feature = {}
    if (type === 'MultiPolygon') {
      // 四层数组
      const multiPolygon = turf.multiPolygon(coordinates)
      feature = turf.feature(multiPolygon.geometry)
    } else if (type === 'Polygon') {
      // 三层数组
      const polygon = turf.polygon(coordinates)
      feature = turf.feature(multiPolygon.geometry)
    }
    return feature
  },

  // 绘制查询也气泡
  drawQueryResultGeojson(features) {
    mapmanager.map.resultLayerGroup.clearLayers()
    for (let i = 0; i < features.length; i++) {
      const feature = features[i]
      if (!feature.geometry) {
        continue
      }
      const latlng = mapmanager.getPolygonCenterPoint(feature)
      let index = 0
      if (feature.index) {
        index = feature.index
      }
      const resultmarker = L.marker(latlng, { icon: markericon.resultMarkerIcon(index, 'red'), riseOnHover: true })
      resultmarker.feature = feature
      resultmarker.index = index

      resultmarker.once('mouseover', e => {
        mapmanager.markerOverHandler(e)
      }).on('mouseout', e => {
        resultmarker.once('mouseover', e => {
          mapmanager.markerOverHandler(e)
        })
        if (!e.target.feature.isSelected) {
          e.sourceTarget.setIcon(markericon.resultMarkerIcon(e.sourceTarget.feature.index, 'red'))
        }
        setTimeout(() => {
          bus.$emit('mouseout', 'mouseout')
        }, 200)
      }).on('click', e => {
        e.target.feature.isSelected = true
        bus.$emit('resultMarkclick', e.target.feature)
      })
      mapmanager.map.resultLayerGroup.addLayer(resultmarker)
    }
    const bounds = mapmanager.map.resultLayerGroup.getBounds()
    const mapBounds = mapmanager.map.getBounds()
    mapBounds.extend(bounds)
    mapmanager.map.fitBounds(mapBounds)
    // mapmanager.closeMarkTooltip(false)
  },
  markerOverHandler(e) {
    bus.$emit('markmouseover', e.target.feature.index)
    if (!e.target.feature.isSelected) {
      e.sourceTarget.setIcon(markericon.resultMarkerIcon(e.sourceTarget.feature.index, 'blue'))
    }
  },

  // 结果列表鼠标选中，地图图标变化
  markerMousemoveHandler(index, status) {
    if (mapmanager.map.resultLayerGroup) {
      const layers = mapmanager.map.resultLayerGroup.getLayers()
      layers.forEach(layer => {
        if (layer.feature.index === index) {
          if (status) {
            layer.setIcon(markericon.resultMarkerIcon(index, 'blue'))
          } else {
            layer.setIcon(markericon.resultMarkerIcon(index, 'red'))
          }
        }
      })
    }
  },

  // 结果列表查看详情，地图图标变化及放大
  markerSelectedHandler(index, status) {
    if (mapmanager.map.resultLayerGroup) {
      mapmanager.map.closePopup()
      const layers = mapmanager.map.resultLayerGroup.getLayers()
      layers.forEach(layer => {
        if (layer.feature.index === index) {
          if (status) {
            const mapBounds = mapmanager.map.getBounds()
            mapBounds.extend(layer.getLatLng())
            mapmanager.map.fitBounds(mapBounds)
            layer.setIcon(markericon.maxResultMarkerIcon(index, 'blue'))
            L.popup({ closeButton: true, className: 'query-reult-popup' })
              .setLatLng(layer.getLatLng())
              .setContent('<div style ="padding: 12px;font-size: 16px;width: 200px; text-align: center;">' + layer.feature.properties.dkmc + '</div>')
              .openOn(mapmanager.map)
            layer.feature.isSelected = true
          } else {
            layer.setIcon(markericon.resultMarkerIcon(index, 'red'))
            layer.feature.isSelected = false
          }
        }
      })
    }
  },

  // 控制是否显示tooltip
  setlandMarkerTooptip(status) {
    if (mapmanager.map.landMarkerLayerGroup) {
      mapmanager.map.closePopup()
      const layers = mapmanager.map.landMarkerLayerGroup.getLayers()
      layers.forEach(layer => {
        if (status) {
          layer.bindTooltip(markericon.getTooltipDiv(layer.feature.properties.dkmc), { direction: 'top', offset: L.point(0, -30) })
        } else {
          layer.unbindTooltip()
        }
      })
    }
  },
  // 放缩至 地图放大位置
  zooomIn(feature) {
    if (feature.geometry) {
      const latlng = mapmanager.getPolygonCenterPoint(feature)
      this.map.flyTo(latlng, 16)
    } else {
      Notification.warning({
        title: '警告',
        message: '飞往该地块出错啦!,该地块尚未上传地块坐标...',
        type: 'warning'
      })
    }
  },
  // 查询周边 绘制查询范围半径
  searchAround(latlng, distance) {
    if (latlng) {
      this.map.searchAroundLayerGroup.clearLayers()
      const layer = L.circle(latlng, { radius: distance })
      this.map.searchAroundLayerGroup.addLayer(L.geoJSON(layer.toGeoJSON()))
      const mapBounds = mapmanager.map.searchAroundLayerGroup.getBounds()
      mapmanager.map.fitBounds(mapBounds)
    } else {
      Notification.warning({
        title: '警告',
        message: '飞往该地点出错啦!',
        type: 'warning'
      })
    }
    mapmanager.searchAroundResultMarkerHandler(false)
  },
  clearPoisLayers() {
    mapmanager.map.searchAroundLayerGroup.clearLayers()
    mapmanager.map.poisLayerGroup.clearLayers()
    mapmanager.searchAroundResultMarkerHandler(true)
  },
  searchAroundResultMarkerHandler(status) {
    const layers = mapmanager.map.resultLayerGroup.getLayers()
    layers.forEach(layer => {
      if (status) {
        layer.setOpacity(1)
      } else {
        layer.setOpacity(0)
      }
    })
  },
  drawPois(pois) {
    this.map.poisLayerGroup.clearLayers()
    for (let i = 0; i < pois.length; i++) {
      const poi = pois[i]
      const latlng = poi.location
      const latlngArray = latlng.split(',')
      const wgs84latlnt = coordinatesconvert.gcj02towgs84(Number(latlngArray[0]), Number(latlngArray[1]))
      const wgs84Array = wgs84latlnt.split(',')
      const resultmarker = L.marker([wgs84Array[0], wgs84Array[1]], { icon: markericon.resultMarkerIcon(i + 1, 'red'), riseOnHover: true })
      resultmarker.index = i + 1
      resultmarker.properties = poi
      this.map.poisLayerGroup.addLayer(resultmarker)
    }
  },
  poisMarkerMousemoveHandler(index, status) {
    if (mapmanager.map.poisLayerGroup) {
      mapmanager.map.closePopup()
      const layers = mapmanager.map.poisLayerGroup.getLayers()
      layers.forEach(layer => {
        if (layer.index === index) {
          if (status) {
            layer.setIcon(markericon.resultMarkerIcon(index, 'blue'))
            L.popup({ closeButton: true, className: 'query-reult-popup' })
              .setLatLng(layer.getLatLng())
              .setContent('<div style ="padding: 7px;font-size: 14px;width: 200px; text-align: center;">' + layer.properties.name + '</div>')
              .openOn(mapmanager.map)
          } else {
            layer.setIcon(markericon.resultMarkerIcon(index, 'red'))
          }
        }
      })
    }
  }

}
export {
  mapmanager,
  LAND_TYPE,
  xzqUtils
}
